export default "__VITE_ASSET__DeN73KMI__"